import { map } from 'rxjs/operators';
/**
 * 将流中的data换为serviceBusEvent
 */
export function dataToServiceBusEvent(event) {
    return (source) => {
        return source.pipe(map((response) => {
            return { type: event.type, isRequest: false, data: response };
        }));
    };
}
/**
 * 将流中的serviceBusEvent转换为data
 *
 */
export function serviceBusEventToData() {
    return (source) => {
        return source.pipe(map((response) => {
            return response.data;
        }));
    };
}
